module.exports = __webpack_public_path__ + "img/pointVert.1b0fb988.svg";